<footer class="border-t border-gray-200 bg-white">
  <div class="mx-auto max-w-7xl px-4 py-10">
    <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
      <ul *ngFor="let col of columns" class="space-y-3 mx-3">
        <li class="list-disc" *ngFor="let link of col">
        <a
          [href]="link.url"
          target="_blank"
          rel="noopener noreferrer"
          class="block text-sm text-gray-700 hover:text-orange-600 hover:underline"
        >
          {{ link.title }}
        </a>
        </li>
      </ul>
    </div>

    <br />
    <hr/>
    <p class="w-full pt-4" align="center">
    © {{ currentYear }} {{ owner }}
    <span *ngIf="siteName"> — {{ siteName }}</span>.
    All rights reserved.
  </p>
  </div>
</footer>
